import { createApi } from '@/api'
export default {
	getStaffList: config => createApi( `/staff/pageSearch`, 'post', config ),
	staffDetail: config => createApi(`/staff/get`, 'get', config),
	addstaff: config => createApi(`/staff/add`, 'post', config),
	deletestaff: config => createApi(`/staff/delete`, 'delete', config),
	updatestaff: config => createApi(`/staff/update`, 'post', config)
}



// WEBPACK FOOTER //
// ./src/views/staffManage/api/index.js